// ANCHOR Base
import { AspectRatioBox, AspectRatioBoxBody } from 'baseui/aspect-ratio-box';
import { Block } from 'baseui/block';
import { LabelMedium } from 'baseui/typography';

// ANCHOR Components
import { constant } from '../../constant';

// ANCHOR Styles
import { BLOCK, TEXT } from './styles';

const MESSAGE = 'Oops, the content failed to load. Try checking to see if the link used was valid.';

export const LionVideoPlayerInvalid = constant(() => (
  <AspectRatioBox aspectRatio={16 / 9}>
    <AspectRatioBoxBody
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Block overrides={BLOCK}>
        <LabelMedium overrides={TEXT}>
          {MESSAGE}
        </LabelMedium>
      </Block>
    </AspectRatioBoxBody>
  </AspectRatioBox>
));
